import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import InputElementWithRef from '@components/InputElementWithRef';
import {getLabelFallback, handleHTTPError} from '@utils/utils';
import PinGeolocate from '@images/svg-icons/pin-geolocate.svg';
import { FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import ShopBag from '@images/svg-icons/shop.svg';
import { usePlacesWidget } from 'react-google-autocomplete';
import { fetchPhysicalStores } from '@utils/services';
import { getMockedPhysicalStore } from '@utils/mockUtils';
import * as actions from '@redux-actions/';
import { DATA_GET_STORE } from '@utils/const';
import Loader from '@components/Loader';


type SearchCardProps = {
    cardTitle?: string;
    zIndex?: string;
    methods?: any;
    config?: any;
    className?: string;
}

const SearchCard = (props: SearchCardProps) : React.ReactElement => {
    const [errorInput, setErrorInput] = useState(null);
    const [errorInputZipCode, setErrorInputZipCode] = useState(null);
    const errorBoss = useSelector((state) => state.cart.errorBoss);
    const [loadingModalBoss, setLoadingModalBoss] = useState(false);
    const radius = useSelector((state) => state.cart.radius);
    const dispatch = useDispatch();

    const {
        cardTitle,
        zIndex,
        methods,
        className,
        config,
    } = props;

    const toggleLockPageScroll = lock => {
        document.querySelectorAll('html,body').forEach(elem => {
          elem.style.overflow = lock ? 'hidden' : '';
          elem.style.position = lock ? 'fixed' : '';
          elem.style.height = lock ? '100%' : '';
          elem.style.width = lock ? '100%' : '';
        });
    };

    const hideLoader = function(){
        setLoadingModalBoss(false);
    }
    const showLoader = function(){
        setLoadingModalBoss(true);
    }

    const openBoss = () => {
        if(config.mockRequests === false) {
            var Geocoder;
            Geocoder = new window.google.maps.Geocoder();
            Geocoder.geocode(
                { address: ref.current.value,
                  componentRestrictions: {
                    country: 'us'
                }
                }, (response, status) => {
                if (status === 'OK' && response.length > 0) {
                    let lng = response[0].geometry.location.lng();
                    let lat = response[0].geometry.location.lat();
            
                    dispatch(actions.setLatitude(lat));
                    dispatch(actions.setLongitude(lng));
            
                    fetchPhysicalStores(
                        props.config.hostname,
                        props.config.storeId,
                        lat,
                        lng,
                        DATA_GET_STORE,
                        radius
                    ).then((res: any) => {
                        if (res && res.recordSetTotal !== '0') {
                            dispatch(actions.setOpenModalBoss(true));
                            hideLoader();
                            document.getElementById("content_wrapper_box").style.zIndex = '999';
                            dispatch(actions.setPhysicalStores(res.PhysicalStore));
                            toggleLockPageScroll(true);
                            setErrorInput(false);
                            window?.tealium_data2track.push({
                                id: 'Event',
                                Store_Search_Keyword: ref.current.value,
                                Store_Search_Type: "text",
                                Store_Search_ResultItemsQnt: res.recordSetTotal,
                                Store_Search_StoreId: res.PhysicalStore[1].storeName,
                                Events_FunnelStoreSearch: '1',
                            });
                        } else if (res && res.recordSetTotal === '0') {
                            setErrorInputZipCode(false);
                            setErrorInput(true);
                            hideLoader();
                            window?.tealium_data2track.push({
                            id: 'Error',
                            Error_Code: 'No store found',
                            Error_Source: 'User',
                            Error_Details: 'No store found',
                            Error_Message: 'No store found. Please enter a zip code, city or state.'
                            })
                        }
                    })
                    .catch(err => {
                        hideLoader();
                        window?.tealium_data2track.push({
                            id: 'Error',
                            Error_Code: 'StoreLocator error',
                            Error_Source: 'Server',
                            Error_Details: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : '',
                            Error_Message: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : ''
                        });

                        console.error(
                            '>>> Error on get Stores for StoreLocator on Search => error status:',
                            err.status,
                            ', error: ',
                            err
                        );
                        handleHTTPError(dispatch, actions, err);
                    });
                } else {
                    let isZipCode = /^[0-9]{5}$/.test(ref.current.value);
                    setErrorInput(true);
                    if (status === 'ZERO_RESULTS' && isZipCode) {
                        setErrorInputZipCode(true);
                        window?.tealium_data2track.push({
                            id: 'Error',
                            Error_Code: 'No store found',
                            Error_Source: 'User',
                            Error_Details: 'No store found',
                            Error_Message: 'No store found. Please enter a zip code, city or state.'
                        })
                    } else {
                        setErrorInputZipCode(false);
                    }
                }
            });
        } else {
            getMockedPhysicalStore()
            .then(res => {
            dispatch(actions.setOpenModalBoss(true));
            document.getElementById("content_wrapper_box").style.zIndex = '999';
            dispatch(actions.setPhysicalStores(res.data.PhysicalStore));
            toggleLockPageScroll(true);
            setErrorInput(false);
            })
            .catch(err => {
            console.log('>>> Read mocked physical store error');
            })
        }
    };
    
    const openBossGeolocate = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
            let lng = position.coords.longitude.toString();
            let lat = position.coords.latitude.toString();

            dispatch(actions.setLatitude(lat));
            dispatch(actions.setLongitude(lng));

            fetchPhysicalStores(
                props.config.hostname,
                props.config.storeId,
                lat,
                lng,
                DATA_GET_STORE,
                radius
            )
                .then((res: any) => {
                if (res && res.recordSetTotal !== '0') {
                    hideLoader();
                    dispatch(actions.setOpenModalBoss(true));
                    document.getElementById("content_wrapper_box").style.zIndex = '999';
                    dispatch(actions.setPhysicalStores(res.PhysicalStore));
                    toggleLockPageScroll(true);
                    setErrorInput(false);
                    window?.tealium_data2track.push({
                        id: 'Event',
                        Store_Search_Keyword: ref.current.value,
                        Store_Search_Type: "geolocalized",
                        Store_Search_ResultItemsQnt: res.recordSetTotal,
                        Store_Search_StoreId: res.PhysicalStore[1].storeName,
                        Events_FunnelStoreSearch: '1',
                    });
                } else if (res && res.recordSetTotal === '0') {
                    hideLoader();
                    setErrorInputZipCode(false);
                    setErrorInput(true);
                    window?.tealium_data2track.push({
                    id: 'Error',
                    Error_Code: 'No store found',
                    Error_Source: 'User',
                    Error_Details: 'No store found',
                    Error_Message: 'No store found. Please enter a zip code, city or state.'
                    })
                }
                })
                .catch(err => {
                hideLoader();
                window?.tealium_data2track.push({
                    id: 'Error',
                    Error_Code: 'StoreLocator error',
                    Error_Source: 'Server',
                    Error_Details: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : '',
                    Error_Message: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : ''
                });

                console.error(
                    '>>> Error on get Stores for StoreLocator on Geolocate => error status:',
                    err.status,
                    ', error: ',
                    err
                );
                handleHTTPError(dispatch, actions, err);
                });
            });
        }
    };

    const { ref } = usePlacesWidget({
        apiKey: config.bossApp.googleApiKey,
        onPlaceSelected: place => console.log(place),
        options: {
          types: ["(regions)"],
          componentRestrictions: { country: 'us' },
        },
    });

    return (
        <Card sx={{ 
            display: 'flex',
            top: 15,
            left: 15,
            width: 480,
            position: 'absolute',
            zIndex: zIndex
            }}
            className={className}>
            <CardContent     
                className="card-content">
                <Typography variant="h5" component="div">
                    <label className="boss-card-header-label">{cardTitle}</label>
                    <p className="boss-card-header-paragraph">{getLabelFallback('BOSS_SUBTITLE_LABEL')}</p>
                </Typography>
                    <FormProvider {...methods}>
                        <form className="container-form" onSubmit={methods.handleSubmit(openBoss)}>
                            <InputElementWithRef
                                ref={ref}
                                classes={'small' + (!!errorInput ? ' error-store-search' : '')}
                                id="zip-code-boss"
                                type="text"
                                placeholder={getLabelFallback('COLLECT_TO_STORE_PLACEHOLDER')}
                                required={true}
                                maxLength={100}
                                />
                            <div className="pin-geolocate" data-element-id="X_X_StoreLocator_Geolocate">
                                <PinGeolocate  onClick={() => {openBossGeolocate(); showLoader();}} />
                            </div>   
                            <button type="submit" onClick={showLoader} className="violet-button" data-element-id="OEE_Search">
                                <Loader classes={"white" + (loadingModalBoss ? " show" : " hide")}/>
                                {getLabelFallback('COLLECT_TO_STORE_BUTTON_LABEL')}
                            </button>  
                        </form>
                    </FormProvider>
                    {(!!errorInput || errorBoss) && (
                        <div className="app-boss-text-error">
                            {errorBoss
                            ? getLabelFallback('BOSS_SEARCH_ERROR_CHECKOUT_LABEL')
                            : errorInputZipCode
                            ? getLabelFallback('BOSS_SEARCH_ERROR_ZIP_CODE_LABEL')
                            : getLabelFallback('BOSS_SEARCH_ERROR_LABEL')}
                        </div>
                        ) }
                    <div className="app-boss-text">
                        <div><ShopBag /></div>
                        <div className="app-boss-text-container">{ getLabelFallback('SUBTITLE_STORE_LOCATOR_MODAL_LABEL') }</div>
                    </div>  
            </CardContent>
        </Card>
    );
}

export default SearchCard;



